module.exports = __webpack_public_path__ + "static/media/CameraSetting.79c6780f.svg";